//此文件定义事件名
//命名规则 全大写 下划线分开 模块名_页面名_事件名_状态名

//权限模块

//通用模块事件
export const AUTH_LOGIN = 'AUTH_LOGIN'; // 登录请求发出
export const AUTH_LOGOUT = 'AUTH_LOGOUT'; // 登录请求发出
export const AUTH_ACCESS = 'AUTH_ACCESS'; // 登录成功
export const GET_MARKET_LINE_LIST = 'GET_MARKET_LINE_LIST';
